(function () {
  'use strict';
  if (window.ApolosSession) return;

  var STORAGE_KEY = 'apolos.session.v1';
  var TOKEN_PATTERN =
    /^[1-9]\d{0,19}\.[a-f0-9]{64}\.[a-f0-9]{64}$/;

  function sessionError(code, message) {
    var error = new Error(message);
    error.code = code;
    return error;
  }

  function emitChange() {
    window.dispatchEvent(
      new CustomEvent('apolos:session-changed')
    );
  }

  function validSession(session) {
    return session &&
      typeof session.token === 'string' &&
      TOKEN_PATTERN.test(session.token) &&
      Number.isSafeInteger(session.expires_at) &&
      session.expires_at > Date.now();
  }

  function assertStorage() {
    var probe = STORAGE_KEY + '.probe';

    try {
      window.sessionStorage.setItem(probe, '1');

      if (window.sessionStorage.getItem(probe) !== '1') {
        throw new Error('storage_unavailable');
      }

      window.sessionStorage.removeItem(probe);
    } catch (error) {
      throw sessionError(
        'storage_unavailable',
        'Your browser is blocking the storage needed to keep you signed in. Please allow site storage and try again.'
      );
    }
  }

  function readSession() {
    try {
      var raw = window.sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;

      var session = JSON.parse(raw);

      if (validSession(session)) return session;

      window.sessionStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      // An unreadable record never establishes a login.
    }

    return null;
  }

  function clearIfCurrent(token) {
    var current = readSession();

    if (current && current.token === token) {
      window.sessionStorage.removeItem(STORAGE_KEY);
      emitChange();
    }
  }

  function accept(session) {
    if (!validSession(session)) {
      throw sessionError(
        'invalid_session',
        'The account response did not contain a valid login session.'
      );
    }

    assertStorage();

    var value = JSON.stringify({
      token: session.token,
      expires_at: session.expires_at
    });

    try {
      window.sessionStorage.setItem(STORAGE_KEY, value);

      if (window.sessionStorage.getItem(STORAGE_KEY) !== value) {
        throw new Error('storage_unavailable');
      }
    } catch (error) {
      throw sessionError(
        'storage_unavailable',
        'The browser could not save your login session.'
      );
    }

    emitChange();
  }

  function storefrontRoot() {
    return (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) || '/';
  }

  async function send(action, token, payload) {
    var response = await fetch(
      storefrontRoot() + 'apps/wishlist?action=' + action,
      {
        method: 'POST',
        credentials: 'same-origin',
        cache: 'no-store',
        redirect: 'error',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(
          Object.assign({}, payload, { session_token: token })
        )
      }
    );

    if (response.status === 401) {
      clearIfCurrent(token);
      return null;
    }

    var data;

    try {
      data = await response.json();
    } catch (error) {
      throw sessionError(
        'service_unavailable',
        'We could not check your account. Please try again.'
      );
    }

    if (!response.ok || !data || data.ok !== true) {
      throw sessionError(
        'service_unavailable',
        'We could not complete the account request. Please try again.'
      );
    }

    return data;
  }

  async function getCustomer() {
    var session = readSession();
    if (!session) return null;

    var data = await send('session', session.token);
    if (!data) return null;

    var current = readSession();

    if (!current || current.token !== session.token) {
      return null;
    }

    if (
      data.authenticated !== true ||
      !data.customer ||
      typeof data.customer.first_name !== 'string' ||
      typeof data.customer.last_name !== 'string' ||
      typeof data.customer.email !== 'string' ||
      !Number.isSafeInteger(data.expires_at) ||
      data.expires_at <= Date.now()
    ) {
      throw sessionError(
        'invalid_response',
        'We could not read your account details. Please try again.'
      );
    }

    return {
      first_name: data.customer.first_name,
      last_name: data.customer.last_name,
      email: data.customer.email,
      expires_at: data.expires_at
    };
  }
  async function accountHub(operation, payload) {
  var session = readSession();
  if (!session) return null;

  var data = await send(
    'account_hub',
    session.token,
    Object.assign({}, payload, {
      operation: operation || 'read'
    })
  );

  if (!data) return null;

  var current = readSession();

  if (!current || current.token !== session.token) {
    return null;
  }

  if (
    data.authenticated !== true ||
    !data.customer ||
    !/^gid:\/\/shopify\/Customer\/[1-9]\d*$/.test(
      data.customer.id || ''
    ) ||
    !Number.isSafeInteger(data.expires_at) ||
    data.expires_at <= Date.now()
  ) {
    throw sessionError(
      'invalid_response',
      'We could not verify your account. Please try again.'
    );
  }

  return data;
}
  async function logout() {
    var session = readSession();
    if (!session) return;

    var data = await send('logout', session.token);

    if (data && data.authenticated !== false) {
      throw sessionError(
        'invalid_response',
        'We could not finish signing you out. Please try again.'
      );
    }

    clearIfCurrent(session.token);
  }

    window.ApolosSession = Object.freeze({
    assertStorage: assertStorage,
    accept: accept,
    getCustomer: getCustomer,
    accountHub: accountHub,
    logout: logout
  });
})();